module.exports = __webpack_public_path__ + "static/media/wine.e2020fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wine.png
// module id = 819
// module chunks = 0